import React, { useEffect, useState } from "react";
import Layout from "../../page/layout";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../../features/authSlice";
import axios from "axios";
import {
  Form,
  Button,
  Card,
  Container,
  Row,
  Col,
  Alert,
  Breadcrumb,
} from "react-bootstrap";
import SuccessModalDasar from "../../component/ModalSuccessDasar";

const PetaniAddLahan = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, user } = useSelector((state) => state.auth);
  const [showModal, setShowModal] = useState(false);

  // States
  const [kategorilahan, setKategoriLahan] = useState("");
  const [lokasilahan, setLokasiLahan] = useState("");
  const [luaslahan, setLuasLahan] = useState("");
  const [periodeTanamMulai, setPeriodeTanamMulai] = useState("");
  const [periodeTanamSelesai, setPeriodeTanamSelesai] = useState("");
  const [namePerusahaan, setNamePerusahaan] = useState("");
  const [namaPerusahaanOptions, setNamaPerusahaanOptions] = useState([]);
  const [msg, setMsg] = useState("");

  const saveLahan = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    try {
      await axios.post(
        `https://c-greenproject.org:8000/petanidasar`,
        {
          kategorilahan,
          namePerusahaan: kategorilahan === "Plasma" ? namePerusahaan : null,
          lokasilahan,
          luaslahan,
          periodeTanamMulai,
          periodeTanamSelesai,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setShowModal(true);
    } catch (error) {
      if (error.response) {
        setMsg(error.response.data.msg);
      }
    }
  };

  useEffect(() => {
    const fetchNamaPerusahaanOptions = async () => {
      try {
        const token = localStorage.getItem("token"); 
        const response = await axios.get(
          "https://c-greenproject.org:8000/perusahaanterdaftar",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setNamaPerusahaanOptions(response.data);
      } catch (error) {
        console.error("Error fetching nama perusahaan options:", error);
      }
    };

    fetchNamaPerusahaanOptions();
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
    if (user && user.role !== "admin" && user.role !== "petani") {
      navigate("/dashboard");
    }
  }, [isError, user, navigate]);

  return (
    <Layout>
      <Container>
        <Breadcrumb>
          <Breadcrumb.Item href="/datalahan">Data Lahan</Breadcrumb.Item>
          <Breadcrumb.Item active>Tambah Data Lahan</Breadcrumb.Item>
        </Breadcrumb>
        <h2>
          <strong>Tambah Data Lahan</strong>
        </h2>
        {msg && <Alert variant="danger">{msg}</Alert>}

        <Card className="p-4 mb-3 shadow">
          <Form onSubmit={saveLahan}>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Kategori Lahan</Form.Label>
                  <Form.Select
                    value={kategorilahan}
                    onChange={(e) => setKategoriLahan(e.target.value)}
                  >
                    <option value="">Pilih Kategori Lahan</option>
                    <option value="Inti">Lahan Inti</option>
                    <option value="Plasma">Lahan Plasma</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              {kategorilahan === "Inti" && (
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Nama Perusahaan</Form.Label>
                    <Form.Select
                      value={namePerusahaan}
                      onChange={(e) => setNamePerusahaan(e.target.value)}
                    >
                      <option value="">Pilih Nama Perusahaan</option>
                      {namaPerusahaanOptions.map((nama, index) => (
                        <option key={index} value={nama}>
                          {nama}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              )}
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Lokasi Lahan</Form.Label>
                  <Form.Control
                    type="text"
                    value={lokasilahan}
                    onChange={(e) => setLokasiLahan(e.target.value)}
                    placeholder="Lokasi Lahan"
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Luas Lahan (ha)</Form.Label>
                  <Form.Control
                    type="number"
                    value={luaslahan}
                    onChange={(e) => setLuasLahan(e.target.value)}
                    placeholder="Luas Lahan"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Periode Tanam Mulai</Form.Label>
                  <Form.Control
                    type="date"
                    value={periodeTanamMulai}
                    onChange={(e) => setPeriodeTanamMulai(e.target.value)}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Periode Tanam Selesai</Form.Label>
                  <Form.Control
                    type="date"
                    value={periodeTanamSelesai}
                    onChange={(e) => setPeriodeTanamSelesai(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Button variant="success" type="submit">
              Save
            </Button>
          </Form>
        </Card>
      </Container>
      <SuccessModalDasar
        show={showModal}
        onClose={() => setShowModal(false)}
        message="Data lahan berhasil disimpan!"
        role="petani"
      />
    </Layout>
  );
};

export default PetaniAddLahan;
